import React, { useState } from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import Login from "./components/Login";
import TravelForm from "./components/TravelForm";
import ReviewSubmit from "./components/ReviewSubmit";
import Confirmation from "./components/Confirmation";
import MyRequests from "./components/MyRequests";
import AdminView from "./components/AdminView";
import "./App.css";

function AppContent() {
  const { accounts } = useMsal();
  const user = accounts[0] || {};
  const isAdmin = user.username?.toLowerCase().startsWith("adm.");

  const [view, setView] = useState(isAdmin ? "admin" : "form");
  const [travelRequests, setTravelRequests] = useState([]);
  const [submittedRef, setSubmittedRef] = useState(null);
  const [behalfUser, setBehalfUser] = useState(null);

  // ── Admin view ──
  if (isAdmin && view === "admin") {
    return (
      <AdminView
        onBack={() => setView("admin")}
        onNewRequest={() => {
          setTravelRequests([]);
          setBehalfUser(null);
          setView("form");
        }}
      />
    );
  }

  // ── History view ──
  if (view === "history") {
    return (
      <MyRequests
        onBack={() => setView(isAdmin ? "admin" : "form")}
      />
    );
  }

  // ── Confirmation view ──
  if (view === "confirmation") {
    return (
      <Confirmation
        travelRequests={travelRequests}
        referenceId={submittedRef}
        isAdmin={isAdmin}
        onNewRequest={() => {
          setTravelRequests([]);
          setSubmittedRef(null);
          setBehalfUser(null);
          setView("form");
        }}
        onViewHistory={() => setView(isAdmin ? "admin" : "history")}
      />
    );
  }

  // ── Review view ──
  if (view === "review") {
    return (
      <ReviewSubmit
        travelRequests={travelRequests}
        behalfUser={behalfUser}
        onBack={() => setView("form")}
        onSubmitted={(refId) => {
          setSubmittedRef(refId);
          setView("confirmation");
        }}
      />
    );
  }

  // ── Travel form ──
  return (
    <TravelForm
      travelRequests={travelRequests}
      setTravelRequests={setTravelRequests}
      onReview={(selectedBehalfUser) => {
        setBehalfUser(selectedBehalfUser);
        setView("review");
      }}
      onViewHistory={() => setView(isAdmin ? "admin" : "history")}
    />
  );
}

export default function App() {
  return (
    <>
      <AuthenticatedTemplate>
        <AppContent />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
}